import { render, staticRenderFns } from "./ExcelRegisterProduct.vue?vue&type=template&id=52d0fdbc&scoped=true&"
import script from "./ExcelRegisterProduct.vue?vue&type=script&lang=js&"
export * from "./ExcelRegisterProduct.vue?vue&type=script&lang=js&"
import style0 from "./ExcelRegisterProduct.vue?vue&type=style&index=0&id=52d0fdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0fdbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDataTable,VFileInput,VRow})
